// components
import GridPageAbstract from '../../GridPageAbstract';
import { DiscountCircleBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';
import i18n from '../../../i18';
import { AddCircleWhiteLinearIcon } from '../../../icons-lib';
import CustomAddXDialog from '../../dialogs/CustomAddXDialog';
import i18 from '../../../i18';

export default class TransactionCouponsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'couponTransactions';
        this.Server = this.props.context.getState().server.couponTransactions;

        this.headerStartIcon = DiscountCircleBulkIcon;
        this.bannerImage = config?.bannerImages?.wallets || '';
        this.hideAddAction = true;

        this.getHeaderActions = () => [
            this.allowedPermission('create') && {
                title: i18n.t('actions.addCoupons'),
                icon: <AddCircleWhiteLinearIcon />,
                onClick: () => this.handleOpenAddCouponsDialog()
            }
        ];

        this.getToolbarActions = () =>
            [
                {
                    title: i18.t('buttons.downloadPdf'),
                    onClick: () => this.handleDownloadPdf()
                }
            ].filter(Boolean);

        this.searchFields = [
            'couponNumber',
            'coin.name',
            'wallet.walletNumber',
            'secret'
        ];

        this.hiddenColumns = config?.hiddenColumns?.couponTransactions || [];

        this.Head = [
            {
                id: 'id',
                label: 'id',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'couponNumber',
                label: 'couponNumber',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'coinId',
                label: 'coin',
                alignRight: false,
                cell: 'Select',
                from: 'coins',
                object: 'coin',
                display: 'name',
                disableGrid: true,
                filterCell: 'Context',
                filterBy: 'coins'
            },
            {
                id: 'amount',
                label: 'amount',
                alignRight: false,
                cell: 'Amount',
                filterCell: 'Range'
            },
            {
                id: 'quantity',
                label: 'quantity',
                alignRight: false,
                cell: 'Number',
                disableGrid: true
            },
            {
                id: 'secret',
                label: 'secret',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'isClaimed',
                label: 'isClaimed',
                alignRight: false,
                cell: 'Boolean',
                object: 'wallet',
                trueLabel: 'claimed',
                falseLabel: 'notClaimed',
                disableEditor: true,
                filterCell: 'Existence',
                filterField: 'wallet'
            },
            {
                id: 'wallet',
                label: 'walletNumber',
                alignRight: false,
                cell: 'Text',
                object: 'wallet',
                display: 'walletNumber',
                disableEditor: true
            },
            {
                id: 'dateExpiry',
                label: 'dateExpiry',
                alignRight: false,
                cell: 'FullDate',
                filterCell: 'Date'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }

    handleOpenAddCouponsDialog() {
        this.setState({ openAddCouponsDialog: true });
    }
    handleCloseAddCouponsDialog() {
        this.setState({ openAddCouponsDialog: false });
    }
    handleSaveAddCouponsDialog() {
        this.setState({ openAddCouponsDialog: false });
        this.retrieveData();
    }
    renderCustom() {
        return (
            <CustomAddXDialog
                dialogOpen={this.state.openAddCouponsDialog}
                title={i18n.t('text.addCoupons')}
                head={this.Head}
                server={this.Server}
                onClose={() => this.handleCloseAddCouponsDialog()}
                onSave={() => this.handleSaveAddCouponsDialog()}
            />
        );
    }
}
